import React from 'react';
import './PhotoBrief.scss';

/**
 * Accessible stand-in for a photograph the chapter has not captured yet.
 *
 * Renders a labelled, non-image plate instead of an <img> pointed at a file
 * that does not exist. `role` is a precise, human-readable description of the
 * photograph the layout calls for (e.g. "Regional convention candid"), and
 * `context` is the situational detail a caption would carry. Both are always
 * rendered as visible text so the gap reads as intentional, not broken.
 *
 * @param {Object} props
 * @param {string} props.role - the photo's subject/role, shown as a heading-weight label
 * @param {string} props.context - supporting detail about the missing photo
 * @param {string} [props.className] - additional class names to merge in
 */
function PhotoBrief({ role, context, className }) {
    const rootClassName = ['PhotoBrief', className].filter(Boolean).join(' ');

    return (
        <figure className={rootClassName} role="img" aria-label={`${role}. ${context}`}>
            <span className="PhotoBrief-role">{role}</span>
            <span className="PhotoBrief-context">{context}</span>
        </figure>
    );
}

export default PhotoBrief;
